namespace $.$$ {
	
	export class $shm_hitalama_textbook_text_header extends $.$shm_hitalama_textbook_text_header {
		
		current() {
			const arg = this.arg()
			const keys = Object.keys( arg )
				.filter( key => arg[ key ] != null )
			
			if( keys.length === 0 ) return false
			
			return keys.every( key => this.$.$mol_state_arg.value( key ) === arg[ key ] )
		}
		
		attr() {
			return {
				... super.attr(),
				shm_hitalama_textbook_text_header_current: this.current() || null,
			}
		}
		
	}
	
}
